import React from 'react';
import {
    Wrapper,
} from "../../../Views/CommonStyles";
import Row from '../../../Shared/Kit/Row';
import Header from '../../../Shared/Header';
import Section1 from '../../../Views/Investments/InvestmentDetails/Section1';
import Section2 from '../../../Views/Investments/InvestmentDetails/Section2';
import Section3 from '../../../Views/Investments/InvestmentDetails/Section3';

const InvestmentDetails = () => {
    return (
        <Wrapper>
            <Header headerColor={"white"} />
            <Row className="content">
                <Row className="section">
                    <Section1 />
                </Row>
                <Row className="section">
                    <Section2 />
                </Row>
                <Row className="section">
                    <Section3 />
                </Row>
            </Row>
        </Wrapper>
    )
}

export default InvestmentDetails;